import React from 'react';
import PropTypes from 'prop-types';

import { reduxForm } from 'redux-form';
import { compose } from 'redux';
import { connect } from 'react-redux';

import validate from './validations';

import { Field } from 'redux-form';
import InputGroup from '../InputGroup';
import Button from '../Button';
import TwoGroup from '../TwoGroup';

import { LoadingSpinner } from '../../components/LoadingSpinner';

import {
    Title,
    Container,
    ButtonGroup,
    MultipleGroupHalf
} from '../../containers/DefaultStyles/FormDetails';

class FindPollingStationForm extends React.Component {
    render() {
        return (
            <Container autocomplete="on" onSubmit={this.props.handleSubmit}>
                <Title>Address Lookup</Title>
                <MultipleGroupHalf>
                    <Field
                        name="address"
                        component={InputGroup}
                        type="text"
                        label="Street No & Street"
                        placeholder="Street No & Street"
                        autocomplete="off"
                    />
                </MultipleGroupHalf>
                <MultipleGroupHalf>
                    <Field
                        name="postalCode"
                        component={InputGroup}
                        type="text"
                        label="Postal code"
                        placeholder="Postal code"
                        autocomplete="off"
                        maxLength={5}
                    />
                </MultipleGroupHalf>
                <ButtonGroup isAddressSubmitting={this.props.isAddressSubmitting}>
                    <TwoGroup>
                        <Button label="Back" onClick={this.props.onBack} />
                        <Button
                            primary={true}
                            type="submit"
                            label="Continue"
                            className="submitButton"
                            disabled={this.props.invalid}
                        />
                        <LoadingSpinner />
                    </TwoGroup>
                </ButtonGroup>
            </Container>
        );
    }
}

FindPollingStationForm.propTypes = {
    onBack: PropTypes.func,
    invalid: PropTypes.bool.isRequired,
    handleSubmit: PropTypes.func,
    isFormSubmitting: PropTypes.bool,
    isAddressSubmitting: PropTypes.bool
};

export default compose(
    connect(state => ({
        initialValues: {
            address: state.cachedFormData.address || '',
            postalCode: state.cachedFormData.postalCode || ''
        }
    })),
    reduxForm({
        form: 'findPollingStationForm',
        destroyOnUnmount: false,
        validate
    })
)(FindPollingStationForm);



// WEBPACK FOOTER //
// ./src/components/FindPollingStation/FindPollingStationForm.jsx